<script lang="ts">
  import { settings, updateSetting } from "../data/settings";
  import { getNow, getTimeZone } from "../data/clock";
  import TimeTraveller from "./time-traveller.svelte";
  import FeatureOnly from "./feature-only.svelte";

  export let time = getNow();
  export let timeZone = getTimeZone();

  $: timeLabel = $time.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    timeZone: $timeZone,
    timeZoneName: "short"
  });

  function updateShowWaypoints(event: Event) {
    let checkbox = event.target as HTMLInputElement;

    updateSetting("showWaypoints", checkbox.checked);
  }
</script>

<svelte:head>
  <FeatureOnly flags={["timemachine"]}>
    <style>
      :root {
        --fab-offset: 30px;
      }
    </style>
  </FeatureOnly>
</svelte:head>

<FeatureOnly flags={["timemachine"]}>
  <footer>
    <div class="Time">
      {timeLabel}
    </div>

    <TimeTraveller />

    <label class="Paths">
      <input type="checkbox" checked={$settings.showWaypoints} on:change={updateShowWaypoints} />
      Paths
    </label>
  </footer>
</FeatureOnly>

<style>
  footer {
    align-items: center;
    background: black;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    border-top: 1px solid rgba(255, 255, 255, 0.12);
    color: white;
    display: flex;
    font-size: 12px;
    justify-content: space-between;
    height: 30px;
    padding: 4px 0;
    text-align: center;
    width: 100%;
    z-index: calc(var(--z-nav) + 1);
  }

  .Time {
    text-align: center;
    white-space: nowrap;
    flex: 0 0;
    padding-inline: 12px;
  }

  .Paths {
    line-height: 1;
    padding-inline: 12px;
    white-space: nowrap;
  }

  .Paths input[type="checkbox"] {
    display: inline-block;
    vertical-align: middle;
  }
</style>
